import { create } from "zustand";
import { persist } from "zustand/middleware";

/** Minimal subscription shape returned by GET /member/me/ (GYM-791). */
export interface MemberActiveSubscription {
  id: string;
  status: string;
  end_date: string | null;
  auto_renew: boolean;
  saved_card_last4: string | null;
  pt_sessions_granted: number;
  pt_sessions_remaining: number | null;
}

/** The logged-in member's own profile (from GET /member/me/). */
export interface CurrentMember {
  id: string;
  member_id: string;
  member_code: string;
  full_name_en: string;
  full_name_ar: string;
  email: string;
  home_branch_name: string | null;
  tenant_name: string | null;
  member_visibility_mode: string | null;
  active_subscription: MemberActiveSubscription | null;
  leaderboard_opt_in?: boolean;
}

interface MemberAuthState {
  access: string | null;
  refresh: string | null;
  member: CurrentMember | null;
  setTokens: (tokens: { access: string; refresh: string }) => void;
  setMember: (member: CurrentMember | null) => void;
  clear: () => void;
}

// Separate persisted store from the staff console (distinct localStorage key)
// so a member session and a staff session never collide on one device.
export const useMemberAuthStore = create<MemberAuthState>()(
  persist(
    (set) => ({
      access: null,
      refresh: null,
      member: null,
      setTokens: ({ access, refresh }) => set({ access, refresh }),
      setMember: (member) => set({ member }),
      clear: () => set({ access: null, refresh: null, member: null }),
    }),
    { name: "gymviz.member.auth" },
  ),
);
